import React from 'react'
import { Select, Icon } from 'antd'
import './QuickOutfitSelect.scss'

const { Option } = Select

/**
 * Quick outfit selection dropdown with built-in stopPropagation
 *
 * @param {Object} props
 * @param {Array} props.outfits - Available outfits
 * @param {Function} props.onSelect - Selection handler (outfit) => void
 * @param {String} props.placeholder - Placeholder text
 * @param {String} props.size - Size of select ('small' | 'default' | 'large')
 * @param {String} props.value - Current selected value (tag or id)
 */
const QuickOutfitSelect = ({
  outfits = [],
  onSelect,
  size = 'small',
  value = undefined
}) => {
  const handleSelect = selectedValue => {
    const outfit = outfits.find(o => (o.tag || o.id) === selectedValue)
    if (outfit && onSelect) {
      onSelect(outfit)
    }
  }

  return (
    <div className="quick-outfit-select" onClick={e => e.stopPropagation()}>
      <Select
        placeholder="Quick Select..."
        onSelect={handleSelect}
        value={value}
        size={size}
        suffixIcon={<Icon type="down" />}
        dropdownMatchSelectWidth={false}
        dropdownStyle={{ minWidth: 220 }}
        showSearch
        filterOption={(input, option) => {
          const outfit = outfits.find(
            o => (o.tag || o.id) === option.props.value
          )
          if (!outfit) return false
          const searchText = (outfit.name || outfit.tag || '').toLowerCase()
          return searchText.includes(input.toLowerCase())
        }}
      >
        {outfits.map(outfit => (
          <Option key={outfit.tag || outfit.id} value={outfit.tag || outfit.id}>
            <div className="quick-select-option">
              <img
                src={outfit.primary_image}
                alt={outfit.name || outfit.tag}
                className="option-image"
              />
              <div className="option-info">
                <span className="option-name">{outfit.name || 'Untitled'}</span>
                <span className="option-tag">{outfit.tag || outfit.id}</span>
              </div>
            </div>
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default QuickOutfitSelect
